import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const c = ({
  title: e,
  titleId: o,
  ...r
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m776.015 658.11 6.677 252.629c.405 14.997-14.421 25.685-28.523 20.587l-227.093-82.219a21.188 21.188 0 0 0-14.507 0l-227.072 82.219c-14.101 5.099-28.949-5.589-28.544-20.587l6.677-252.629a21.255 21.255 0 0 0-4.011-13.035L110.691 438.867c-8.576-11.883-2.837-28.693 11.2-32.875l232.171-69.248c4.864-1.472 9.067-4.629 11.797-8.896l136.043-211.413c8.405-13.013 27.435-13.013 35.84 0l136.043 211.413a21.403 21.403 0 0 0 11.819 8.896l232.171 69.248c14.037 4.181 19.755 20.992 11.179 32.875L780.026 645.075a21.398 21.398 0 0 0-4.011 13.035",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s = i(c);
export {
  s as default
};
